import { ColorVariant } from '../../components'
import { FinancialsSubRowDataType } from '../../components/financials-table/types'
import { View } from '../../components/line-stacked-bar-chart'

export enum TrafficDataViewEnum {
  visits = 'visits',
  momChangePct = 'momChangePct',
}

export enum AppRegion {
  us = 'us',
  ww = 'ww',
}

export enum AppPlatform {
  ios = 'ios',
  android = 'android',
}

export type TrafficSettings = {
  trafficDataView: TrafficDataViewEnum
  chartView: View
  appRegions: AppRegion[]
  appPlatforms: AppPlatform[]
}

export interface InitialTrafficData {
  trafficTickers: string[]
  companyName: string
  mainDomain?: string | null
  trafficsWithPeers: TrafficItem[]
  appsWithPeers: AppItem[]
}

export interface ParsedTrafficData extends Omit<InitialTrafficData, 'trafficsWithPeers' | 'appsWithPeers'> {
  trafficsWithPeers: ParsedTrafficItem[]
  appsWithPeers: ParsedAppItem[]
}

export interface TrafficItem {
  domain?: string | null
  industry?: string | null
  industryGroup?: string | null
  heatmapSector?: string | null
  heatmapSubSector?: string | null
  peers?: string | null
  sector?: string | null
  ticker: string | null
  trafficJson?: string | null
}

export type ParsedTrafficItem = Omit<TrafficItem, 'trafficJson'> & {
  traffic: {
    d: number[]
    v: number[]
  } | null
}

export interface AppItem {
  domain?: string
  appId?: string | null
  appName?: string | null
  os?: string | null
  geo?: string | null
  mauJson?: string | null
}

export type ParsedAppItem = Omit<AppItem, 'mauJson' | 'os' | 'geo'> & {
  id: string
  os: AppPlatform | null
  geo: AppRegion | null
  mau: {
    d: number[]
    v: number[]
  } | null
}

export type TrafficSubRowDataType = Omit<FinancialsSubRowDataType, 'values' | 'keyValueMap'> & {
  values: Array<{ year: string; value: number | null; momValue?: number | null }>
  keyValueMap: Record<string, number | null>
  momKeyValueMap: Record<string, number | null>
}

export type TrafficRowDataType = TrafficSubRowDataType & {
  isSelected: boolean
  isHighlighted: boolean
  color: ColorVariant
}
